export default "__VITE_ASSET__ccdeccde__"